import { useDispatch } from "react-redux";
import { CHAT_BOT } from "../utils/constants";
import React, { useEffect, useRef, useState } from "react";
import { addBot, horoscopeBot } from "../store/configAppSlice";
import { toast, Bounce } from "react-toastify";
import Cookies from "js-cookie";
import { getChat } from "../Service/UserService";
import logo from "../image/Logo.png";
import ailogo from "../image/ai-chat-logo.png";
import peoplelogo from "../image/ai-people-logo.png";
import Slider from "react-slick";
import Typewriter from "typewriter-effect";

const DailyHoroscopeBox = () => {
  const input = useRef();
  const dispatch = useDispatch();
  const chatEndRef = useRef(null);
  const typewriterRef = useRef(null);


  const handleHoroscope = () => dispatch(horoscopeBot());

  return (
    <div className="fixed w-full left-0 top-0 z-20 h-screen rounded-xl flex flex-col items-center bg-zinc-950 bg-opacity-85">
      <div className="relative lg:w-[70%] pt-28 w-full rounded-xl overflow-hidden">
        <div className="w-full flex justify-between rounded-t-xl items-center bg-purple-700 py-4 px-4">
          <div className="flex items-center">
            <img className="w-10 lg:w-14" src={logo} alt="logo" />
            <span className="text-2xl text-purple-200 font-semibold uppercase">
              {CHAT_BOT}
            </span>
          </div>
          <span className="text-xl text-purple-200 font-semibold">Daily Horoscope Pridiction</span>

          <i
            className="text-3xl text-purple-300 ri-close-fill cursor-pointer"
            onClick={handleHoroscope}
          ></i>
        </div>

        <div className="overflow-y-scroll px-4 py-3 h-[65vh] bg-purple-950 text-white text-center relative">
         
        </div>
      </div>
    </div>
  );
};

export default DailyHoroscopeBox;
